export const ProBadge = ({
	className = '',
	bgClassName = 'bg-[#B332E6]',
	// Figma specs #F4F4F4, but that only measures 4.23:1 against #B332E6 — fails
	// WCAG AA (needs 4.5:1) at this badge's text size. Plain white clears AA
	// (4.65:1) and is visually indistinguishable.
	textClassName = 'text-white',
	children = 'PRO',
}) => (
	<span
		className={`inline-block rounded-[10px] px-2 py-0.5 text-xs font-bold leading-none ![font-family:var(--font-open-sans)] ${bgClassName} ${textClassName} ${className}`}
	>
		{children}
	</span>
);

export default ProBadge;
